export default {"src":"/_next/static/media/2d-side-gray.d069beba.svg","height":25,"width":22};